import React, {useContext, useEffect, useState} from 'react';
import PageIntroSection from "../components/PageIntroSection/PageIntroSection";
import HotelsListItem from "../components/Hotel-list-item/Hotels-list-item";
import {LangContext} from "../App";
import {axios} from "../axios";
import Seo from "../components/Seo/Seo";

const content = {
    en: {
        heroTitle: "Apartments in Armenia",
        heroText: "Browse apartments and choose a place to stay during your visit to Armenia.",
    },
    de: {
        heroTitle: "Ferienwohnungen in Armenien",
        heroText: "Durchsuchen Sie die Ferienwohnungen und wählen Sie eine Unterkunft für Ihren Aufenthalt in Armenien.",
    },
};

const Apartment = () => {
    const [data,setData] = useState([])
    const lang = useContext(LangContext)
    const t = content[lang] || content.en
    useEffect(()=>{
        axios.get(`${lang}/apartment`)
            .then(res => setData(res.data.tours))
            .catch(() => setData([]))

    },[lang])
    return (
        <div className='hotels-page'>
            <Seo pageKey="apartments" />
            <PageIntroSection title={t.heroTitle} text={t.heroText}/>
            <div className="center-wrapper">
                <div className="hotels-list">
                    {data.map((e,i) => <HotelsListItem path='apartment-page' key={e.id} tour={e} i={i}/> )}
                </div>
            </div>
        </div>
    );
};

export default Apartment;